var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"schoolblocks",class:{ touch: _vm.hasTouch }},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1),_c('sb-footer',{class:{ large: _vm.layout === 'clean-layout' }})],1)}
var staticRenderFns = []

export { render, staticRenderFns }